export default class Ajax {
    static url = process.env.REACT_APP_STOREURL + "/sideb.php";

    static editorId = 0;
    static setEditorId( id:number ){
        Ajax.editorId = id;
    }

    static getUrl = ()=>{
        return Ajax.url;
    }
    
    static send = (path:string,json:{[key:string]:any;},func:any,errorFunc?:any)=>{
        //console.log("send",path,json);
        const sp = path.split("/");

        json["mod"] = sp[0];
        json["act"] = sp[1];

        if( Ajax.editorId>0 ){
            json["editor_id"] = String(Ajax.editorId);
        }
        let url = Ajax.url;

        fetch(url, {
            method : 'POST',
            body:JSON.stringify(json),
            //body:fd,
            //mode: "cors",
            //headers : new Headers({ "Content-type" : "application/json" }),
            credentials: "include",
        }).then(response => response.json())
        .then((json) => {
            //alert(text);
            func(json);
        })
        .catch(err => {
			//console.log("send",path,json);
			//console.log(json);
			console.log("path:",path);
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
            if( errorFunc ){
                errorFunc(err);
            }
        });
    }
    static sendAwait = async (path:string,json:{[key:string]:any;})=>{
        const sp = path.split("/");

        json["mod"] = sp[0];
        json["act"] = sp[1];

        if( Ajax.editorId>0 ){
            json["editor_id"] = String(Ajax.editorId);
        }
        let url = Ajax.url;

        return await fetch(url, {
            method : 'POST',
            body:JSON.stringify(json),
            credentials: "include",
        }).then(response => response.json())
        .catch(err => {
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
        });
    }
    static search = (path:string,data:any,page:number,func:any)=>{
        const sp = path.split("/");

        //console.log("search",data);

        let fd = new FormData();
        fd.append("mod", sp[0]);
        fd.append("act", sp[1]);
        fd.append("p", page.toString());

        if( Ajax.editorId>0 ){
			//console.log("editorId",Ajax.editorId);
            fd.append("editor_id", String(Ajax.editorId));
        }

        for(const key in data){
            let v = data[key];
            if( key!=="option" ){
                if( v===true ){
                    v = "1";
                } else if( v===false ){
                    v = "0";
                }
                fd.append("search_"+key,v);
            } else {
                fd.append("search_order",v.order);
                fd.append("search_sort",v.sort);
                fd.append("search_per_page",v.per_page);
            }
        }

        fetch(Ajax.url, {
            method : 'POST',
            body:fd,
            //headers : new Headers({ "Content-type" : "application/json" }),
            credentials: "include",
        }).then(response => response.json())
        .then((json) => {
            //alert(text);
            func(json);
        })
        .catch(err => {
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
        });
    }
    static upload = (path:string,data:any,func:any)=>{
        const sp = path.split("/");

        //console.log("send",data);

        let fd = new FormData();
        fd.append("mod", sp[0]);
        fd.append("act", sp[1]);

        if( Ajax.editorId>0 ){
            fd.append("editor_id", String(Ajax.editorId));
        }

        for(const key in data){
            let v = data[key];
            fd.append(key,v);
        }

        fetch(Ajax.url, {
            method : 'POST',
            body:fd,
            credentials: "include",
        }).then(response => response.json())
        .then((json) => {
            func(json);
        })
        .catch(err => {
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
        });
    }

    static download = (path:string,json:{[key:string]:any;},func:any)=>{
        //console.log("download",json);

        const sp = path.split("/");
        json["mod"] = sp[0];
        json["act"] = sp[1];

        if( Ajax.editorId>0 ){
            json["editor_id"] = String(Ajax.editorId);
        }
        let url = Ajax.url;


        fetch(url, {
            method : 'POST',
            body:JSON.stringify(json),
            credentials: "include",
        }).then(response => response.blob())
        .then((blob) => {
            const dt = new Date();
            const today = dt.getFullYear() + ('00' + (dt.getMonth()+1)).slice(-2) + ('00' + dt.getDate()).slice(-2);
            let name = "リスト_"+today+".pdf";
            if( json["filename"] ){
                name = json["filename"]+"_"+today+".pdf";
            }
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);

            document.body.appendChild(link);

            link.click();

            if( link.parentNode ){
                link.parentNode.removeChild(link);
            }
            func({"ok":true});
        })
        .catch(err => {
            console.log('rejected:', err); // rejected: TypeError: Failed to fetch
        });
    }

}